/**
 * rPI Porter — Channels config hook (E-102 P2-1)
 *
 * Backing API: `apps/kgc-web/src/api/porter-channels.ts`
 *
 * staleTime = 30 s: channel config changes rarely — the webhook-driven mirror
 * is updated only when the owner re-provisions Chatwoot. A longer staleTime
 * avoids fetching on every page re-entry, but short enough to pick up a
 * same-day config tweak within one full refresh.
 */

import { getChannels } from '@/api/porter-channels';
import { useQuery } from '@tanstack/react-query';

const CHANNELS_STALE_MS = 30_000;

export function usePorterChannels() {
  return useQuery({
    queryKey: ['porter', 'channels'] as const,
    queryFn: getChannels,
    staleTime: CHANNELS_STALE_MS,
  });
}
